import React, { useEffect, useState } from 'react'

import { Container } from './styles'
import Box from '@mui/material/Box'
import { Button, Card, Chip } from '@mui/material'
import { useModalContext } from '../../contexts/ModalContext'
import DataTable from 'react-data-table-component'
import DataTableExtensions from 'react-data-table-component-extensions'
import 'react-data-table-component-extensions/dist/index.css'
import * as OffersService from '../../services/mechanicActivityOffers'
import RuleFolderIcon from '@mui/icons-material/RuleFolder'
import ApproveOrDenyModal from './ApproveOrDenyModal'
import { getOfferDiscountPercent, getOfferMechanicName } from './offerDisplay'

const Status = {
    APPROVED: {
        text: 'APROVADO',
        color: '#2e7d32'
    },
    PENDING: {
        text: 'PENDENTE',
        color: '#1565c0'
    },
    DENIED: {
        text: 'NEGADO',
        color: '#c62828'
    }
}

function formatDateOnly(dateStr) {
    if (!dateStr) return '—'
    const datePart = String(dateStr).slice(0, 10)
    const [y, m, d] = datePart.split('-').map(Number)
    if (!y || !m || !d) return dateStr
    return new Date(y, m - 1, d).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    })
}

function activityCell(row) {
    const label = row.activityName || row.activityTitle || row.catalogActivityName
    if (label) {
        return (
            <div style={{ whiteSpace: 'normal', fontSize: '13px' }}>
                <div>{label}</div>
                <div style={{ color: '#666' }}>ID: {row.activityId}</div>
            </div>
        )
    }
    return row.activityId
}

function establishmentCell(row) {
    const name = getOfferMechanicName(row)
    if (name) {
        return (
            <div style={{ whiteSpace: 'normal', fontSize: '13px' }}>
                <div>{name}</div>
                <div style={{ color: '#666' }}>ID: {row.mechanicId}</div>
            </div>
        )
    }
    return row.mechanicId
}

const Offers = () => {
    const { setModal } = useModalContext()
    const [data, setData] = useState([])

    useEffect(() => {
        fetchTableData()
    }, [])

    async function fetchTableData() {
        await OffersService.getAll().then((response) => {
            setData(response)
        })
    }

    const columns = [
        {
            id: 'id',
            name: 'ID',
            selector: (row) => row.id,
            sortable: true,
            width: '70px'
        },
        {
            id: 'mechanicId',
            name: 'Estabelecimento',
            selector: (row) => getOfferMechanicName(row) || String(row.mechanicId),
            cell: (row) => establishmentCell(row),
            sortable: true,
            width: '16%'
        },
        {
            name: 'Atividade',
            selector: (row) => row.activityId,
            cell: (row) => activityCell(row),
            sortable: true,
            width: '18%'
        },
        {
            name: 'Desconto',
            selector: (row) => getOfferDiscountPercent(row) ?? -1,
            cell: (row) => {
                const pct = getOfferDiscountPercent(row)
                return pct != null ? `${pct}%` : '—'
            },
            sortable: true,
            width: '90px'
        },
        {
            name: 'Válida até',
            selector: (row) => row.validUntil,
            cell: (row) => formatDateOnly(row.validUntil),
            sortable: true,
            width: '110px'
        },
        {
            name: 'Status',
            cell: (row) => {
                const status = Status[row.status] || { text: row.status, color: 'gray' }
                return (
                    <Chip
                        label={status.text}
                        size='small'
                        sx={{
                            backgroundColor: status.color,
                            color: 'white',
                            fontWeight: 'bold',
                            fontSize: '11px'
                        }}
                    />
                )
            },
            width: '120px'
        },
        {
            name: 'Ações',
            cell: (row) => (
                <Box display='flex' gap='4px'>
                    <Button
                        variant='outlined'
                        size='small'
                        style={{ background: '#1565c0', color: 'white', minWidth: '36px' }}
                        onClick={() => setModal(<ApproveOrDenyModal updateTable={fetchTableData} offer={row} />)}
                        title='Gerenciar'
                    >
                        <RuleFolderIcon fontSize='small' />
                    </Button>
                </Box>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '90px'
        }
    ]

    return (
        <Container>
            <Box mb={3} fontWeight='bold' fontSize={{ xs: 'h7.fontSize', sm: 'h6.fontSize', md: 'h5.fontSize' }}>
                Ofertas de Atividades
            </Box>
            <Box mb={3} fontSize={{ xs: 'h9.fontSize', sm: 'h9.fontSize', md: 'h8.fontSize' }}>
                Descontos por atividade enviados por estabelecimentos para aprovação (super admin)
            </Box>
            <Box mt={3} mb={5}>
                <Card>
                    <DataTableExtensions columns={columns} data={data} export={false} print={false}>
                        <DataTable
                            pagination
                            paginationPerPage={15}
                            highlightOnHover
                            defaultSortFieldId='id'
                            defaultSortAsc={false}
                        />
                    </DataTableExtensions>
                </Card>
            </Box>
        </Container>
    )
}

export default Offers
